// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../ViewStack.bs.js");
var Text__Jsx3 = require("../../../uikit/reason/helpers/Text__Jsx3.bs.js");
var Attachments = require("./Attachments.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");

function UnsupportedAttachmentsDialog(props) {
  var onDismiss = props.onDismiss;
  var files = props.files;
  var isOpen = files.length !== 0;
  return JsxRuntime.jsx(DialogV5.make, {
              title: "Unsupported Files",
              isOpen: isOpen,
              ariaLabel: "Unsupported Files",
              onDismiss: onDismiss,
              children: JsxRuntime.jsxs(ViewStack.make, {
                    space: "lg",
                    flexDirection: "column",
                    children: [
                      JsxRuntime.jsxs(Text__Jsx3.make, {
                            fontSize: {
                              NAME: "px",
                              VAL: 15
                            },
                            lineHeight: {
                              NAME: "float",
                              VAL: 1.5
                            },
                            children: [
                              Attachments.makeUnsupportedFileErrorText(files),
                              JsxRuntime.jsx("br", {}),
                              JsxRuntime.jsx("br", {}),
                              "You can attach images (JPEG, PNG, GIF, PNG), videos (MP4, Quicktime), PDFs, documents and spreadsheets"
                            ]
                          }),
                      JsxRuntime.jsx(ViewStack.make, {
                            width: {
                              NAME: "percent",
                              VAL: 100
                            },
                            justifyContent: "flexEnd",
                            flexDirection: "row",
                            children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                                      onClick: (function (param) {
                                          onDismiss();
                                        }),
                                      size: "large",
                                      children: "Dismiss"
                                    }))
                          })
                    ]
                  })
            });
}

var make = UnsupportedAttachmentsDialog;

exports.make = make;
/* DialogV5 Not a pure module */
